import { clearCookies, getCookie } from "../Utils/cookies";
import AuthService from "../Services/authService/AuthService";
import React, { createContext, useEffect, useState } from "react";

export const UserContext = createContext(null);

const USER_ID = "userId";
const USERNAME = "username";

export const UserContextProvider = ({ children }) => {
  const [isAuth, setIsAuth] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    getCookie("authorization") ? setIsAuth(true) : setIsAuth(false);

    const userId = localStorage.getItem(USER_ID);
    const username = localStorage.getItem(USERNAME);

    setUserInfo({ username, userId });
  }, []);

  const login = async (body) => {
    const result = await AuthService.login(body);

    if (result) {
      setUserInfo({
        userId: result.id,
        username: result.username,
      });

      localStorage.setItem(USER_ID, result?.id);
      localStorage.setItem(USERNAME, result?.username);

      setIsAuth(true);
    }
  };

  const register = async (values) => {
    const body = mapRegisterBody(values);
    if (!body) {
      return null;
    }
    const result = await AuthService.register(body);

    if (result) {
      setUserInfo({
        userId: result.id,
        username: result.username,
      });

      localStorage.setItem(USER_ID, result.id);
      localStorage.setItem(USERNAME, result.username);
      setIsAuth(true);
    }
  };

  const mapRegisterBody = (values) => {
    if (!values || !Object.entries(values).length) {
      return null;
    }

    return {
      password: values?.password,
      passwordHint: values?.passwordHint,
      recoveryEmail: values?.recoveryEmail,
      username: values?.username,
    };
  };

  const logout = async () => {
    try {
      await AuthService.logout();
    } catch (error) {
      console.error(error.message, error.error, error.status);
      clearCookies();
    }

    localStorage.removeItem(USERNAME);
    localStorage.removeItem(USER_ID);
    setUserInfo(null);
    setIsAuth(false);
  };

  const value = {
    isAuth,
    login,
    logout,
    register,
    setIsAuth,
    setUserInfo,
    userInfo,
  };

  return <UserContext.Provider value={value}> {children} </UserContext.Provider>;
};

export default UserContext;
